import axios from "axios";
// config
import axiosInstance from "./config";

const ROUTE = "account";

export const signInRequest = async (requestData) =>
  axios
    .post(`${process.env.REACT_APP_SERVER_URL}/${ROUTE}/signin/`, requestData)
    .then((response) => {
      localStorage.setItem("access_token", response.data.access);
      localStorage.setItem("refresh_token", response.data.refresh);
      axiosInstance.defaults.headers.Authorization = `JWT ${localStorage.getItem(
        "access_token"
      )}`;
      window.dispatchEvent(new Event("storage"));
      return response.data;
    });

export const signOutRequest = async () =>
  axiosInstance
    .post(`${ROUTE}/sign-out/`, {
      refresh_token: localStorage.getItem("refresh_token"),
    })
    .then((response) => {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      return response.data;
    });
